import { getRailsClient } from "../client";

import { TournamentDetails } from "./types/tournamentTypes";

export const fetchUserTournaments = async (): Promise<TournamentDetails[]> => {
  const API = "/api/internal_api/v2/tournaments";
  const client = getRailsClient();

  const { data } = await client.get<TournamentDetails[]>(API);
  return data;
};

export const fetchFinishedTournaments = async (): Promise<TournamentDetails[]> => {
  const API = `/api/internal_api/v2/tournaments/finished`;

  try {
    const { data } = await getRailsClient().get<TournamentDetails[]>(API);
    return data;
  } catch (error) {
    console.error("Error fetching finished tournaments:", error);
    return [];
  }
};

export const fetchTournamentById = async (tournamentId: string): Promise<TournamentDetails> => {
  const API = `/api/internal_api/v2/tournaments/${tournamentId}`;

  try {
    const { data } = await getRailsClient().get<TournamentDetails>(API);
    return data;
  } catch (error) {
    console.error(`Error fetching tournament with ID ${tournamentId}:`, error);
    throw error;
  }
};

export const enrollInTournament = async (tournamentId: number): Promise<void> => {
  const API = `/api/internal_api/v2/tournaments/${tournamentId}/enroll_in_tournament`;

  try {
    await getRailsClient().post(API);
  } catch (error) {
    console.error(`Error enrolling in tournament ${tournamentId}:`, error);
    throw error;
  }
};

export const startTournamentLesson = async (exerciseId: string): Promise<string> => {
  const API = `/api/internal_api/v2/tournament_contents/${exerciseId}/start_exercise`;

  try {
    const { data } = await getRailsClient().post<string>(API);
    return data;
  } catch (error) {
    console.error(`Error starting tournament lesson ${exerciseId}:`, error);
    throw Error;
  }
};
